import { useTranslation } from '@blocs.i18n';

export const useExtraWorkText = () => {
  const { t } = useTranslation();

  return t('common:label.willingToDoExtraWork');
};
